import React from 'react';

export function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className="py-2 md:py-6 px-2 md:px-0">
          {children}
        </div>
      )}
    </div>
  );
} 